export const environment = {
  production: true,
  apiUrlControleDeAcesso: 'https://controleacesso-portal-novo.acrefi.org.br/api',
  apiUrlPortal: 'https://api-portal-novo.acrefi.org.br/api',
  apiWordpress: 'novo.acrefi.org.br',
  webSite: 'novo.acrefi.org.br'
};
